import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import storesPlugin from './stores/plugin'
import router from './router'
import axios from 'axios'
import setAuthHeader from './authorization'
import './assets/main.css';
// import { createAuth0 } from '@auth0/auth0-vue'

// import Vue from 'vue';
import { createI18n } from "vue-i18n";

// /* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// /* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

// /* import all icons of same type */
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';

// /* import specific icons */
// import { faPenToSquare } from '@fortawesome/free-solid-svg-icons'
// import { xMark } from '@fortawesome/free-solid-svg-icons'
// import { faTrashCan } from '@fortawesome/free-regular-svg-icons'


// /* add icons to the library */
library.add(fas, far);

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  contentType: 'application/json'

});

if(localStorage.token){
    setAuthHeader(localStorage.token);
}else{
    setAuthHeader(false);
}

// Initialiser currentCompany si il n'existe pas mais que companies existe
function initializeCurrentCompany() {
  try {
    const currentCompany = localStorage.getItem('currentCompany');
    if (!currentCompany) {
      const companies = JSON.parse(localStorage.getItem('companies') || '[]');
      const companyId = localStorage.getItem('companyId');
      
      if (companyId && companies.length > 0) {
        const company = companies.find(c => c.id == companyId);
        if (company) {
          localStorage.setItem('currentCompany', JSON.stringify(company));
        }
      }
    }
  } catch (error) {
    console.warn('Erreur lors de l\'initialisation de currentCompany:', error);
  }
}

// Initialiser currentCompany au démarrage
initializeCurrentCompany();

// import translations
import fr from "./locales/fr.json";
import en from "./locales/en.json";
import es from "./locales/es.json";
import it from "./locales/it.json";

// configure i18n
const language = localStorage.getItem('language') || 'fr';
const i18n = createI18n({
  locale: language,
  fallbackLocale: "fr",
  messages: { fr, en, es, it },
});


// Ajouter un intercepteur de réponse
instance.interceptors.response.use(response => {
  // Si la réponse est une réussite, la retourner sans modifications
  return response;
}, error => {
  console.log('interceptor error', error);
  // Vérifier si l'erreur est une erreur 400 et contient le message "wrong token"
  if (error.response && error.response.status === 401 && error.response.data.message === 'wrong token') {
    // Rediriger l'utilisateur vers la page de login
    router.push('/login');
  }
  if (error.response && error.response.status === 404 || error.response.status === 403) {
    router.push('/not-found');
  }

  // Renvoyer une promesse rejetée contenant l'erreur
  return Promise.reject(error);
});

// no value change when scrolling on the input
document.addEventListener('wheel', function(event) {
  if (document.activeElement.type === 'number') {
    event.target.blur();
  }
}, { passive: false });

// create and start the app
const app = createApp(App);
const pinia = createPinia();
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(pinia);
app.use(storesPlugin);
app.use(router);
app.use(i18n);
// app.use(
//   createAuth0({
//     domain: 'dev-paxkr6w6deleq164.us.auth0.com',
//     clientId: 'R7ispQSf1GI9TcoYSDSzjLfppTgnpjco',
//     authorizationParams: {
//       redirect_uri: 'http://localhost:8080'
//     }
//   })
// );
app.mount("#app");

export default instance;
